// test1372
(1372 && 0);
